/**
 * @fileOverview 全局变量
 * @author dxq613
 */
var Util = require('./util');

var Theme = require('./theme/index');

var Global = {
  version: '3.5.9-beta.1',
  renderer: 'canvas',
  // trackable: false,
  trackingInfo: {},
  animate: true,
  widthRatio: {
    // 宽度所占的分类的比例
    column: 1 / 2,
    // 一般的柱状图占比 1/2
    rose: 0.9999999,
    // 玫瑰图柱状占比 1
    multiplePie: 1 / 1.3 // 多层的饼图、环图

  },
  // 折线图、区域图、path 当只有一个数据时，是否显示成点
  showSinglePoint: false,
  connectNulls: false,
  scales: {},
  registerTheme: function registerTheme(name, theme) {
    Theme[name] = theme;
  },
  setTheme: function setTheme(theme) {
    var newTheme = {};

    if (Util.isObject(theme)) {
      newTheme = theme;
    } else if (Util.indexOf(Object.keys(Theme), theme) !== -1) {
      newTheme = Theme[theme];
    } else {
      newTheme = Theme.default;
    }

    Util.deepMix(Global, newTheme);
  }
};
Global.setTheme('default');
module.exports = Global;


//////////////////
// WEBPACK FOOTER
// ./src/global.js
// module id = 7
// module chunks = 0 1 2